import React from 'react';


const EditIcon = ({stroke = '#777777'}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
      <path d="M7.5625 2.75H2.75C2.38533 2.75 2.03559 2.89487 1.77773 3.15273C1.51987 3.41059 1.375 3.76033 1.375 4.125V13.75C1.375 14.1147 1.51987 14.4644 1.77773 14.7223C2.03559 14.9801 2.38533 15.125 2.75 15.125H12.375C12.7397 15.125 13.0894 14.9801 13.3473 14.7223C13.6051 14.4644 13.75 14.1147 13.75 13.75V8.9375" stroke={stroke} strokeWidth="1.375" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12.7188 1.71874C12.9923 1.44523 13.3632 1.29158 13.75 1.29158C14.1368 1.29158 14.5077 1.44523 14.7812 1.71874C15.0548 1.99224 15.2084 2.36319 15.2084 2.74999C15.2084 3.13678 15.0548 3.50773 14.7812 3.78124L8.25 10.3125L5.5 11L6.1875 8.24999L12.7188 1.71874Z" stroke={stroke} strokeWidth="1.375" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default EditIcon;
